import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcademicComponent } from 'src/app/view/campus/academic/academic.component';
import { AdministrativeComponent } from 'src/app/view/campus/administrative/administrative.component';
import { CampusComponent } from 'src/app/view/campus/campus.component';
import { GroundComponent } from 'src/app/view/campus/ground/ground.component';
import { InfraComponent } from 'src/app/view/campus/infra/infra.component';
import { LabsComponent } from 'src/app/view/campus/labs/labs.component';
import { MusicComponent } from 'src/app/view/campus/music/music.component';
import { TransportComponent } from 'src/app/view/campus/transport/transport.component';
import { RouterModule } from '@angular/router';
import { CampusRoutingModule } from './campus-routing.module';



@NgModule({
  declarations: [
    CampusComponent,
    AdministrativeComponent,
    AcademicComponent,
    MusicComponent,
    LabsComponent,
    GroundComponent,
    TransportComponent,
    InfraComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CampusRoutingModule
  ]
})
export class CampusModule { }
